<template>
  <div class="text-center">
    <span
      class="text-theme-600 text-xs font-normal me-2 px-2.5 py-0.5 rounded-full border border-theme-400"
      >{{ item }}</span
    >
  </div>
</template>

<script setup lang="ts">
defineProps<{
  header: string;
  item: string;
}>();
</script>
